import React, { useEffect, useRef } from 'react'
import { useAuth } from 'oidc-react'
import getEnv from '../lib/get-env.js'

import { saveTokenCookie } from '../lib/save-token-cookie.js'
import { getAccountUserinfo } from '../lib/get-account-userinfo.js'
import { getAuthVendorIdentityType } from '../lib/get-account-identity-types.js'
import { getAccountIdentityAssignment } from '../lib/get-account-identity-assignments.js'
import { addAccountIdentityAssignment } from '../lib/add-account-identity-assignment.js'

const cookieName = getEnv('REACT_APP_TOKEN_COOKIE_NAME')
const accountUrl = getEnv('REACT_APP_ACCOUNT_URL')

async function addIdentity({ bearerToken, userData }) {
  let userAccountInfo = await getAccountUserinfo({ bearerToken })
  if (!userAccountInfo) {
    console.error('Error in addIdentity: userAccountInfo not found')
    return
  }

  let accountUserId = userAccountInfo?.sub
  const identityType = await getAuthVendorIdentityType({
    bearerToken,
    userData,
  })

  if (!identityType) {
    console.error('Error in addIdentity: identityType not found')
    return
  }

  const identityAssignment = await getAccountIdentityAssignment({
    bearerToken,
    accountUserId,
    authVendorUserId: userData.profile.sub,
    identityTypeId: identityType.id,
  })

  if (identityAssignment) {
    console.error('Error in addIdentity: identityAssignment already exists')
    return
  }

  // add identity assignment
  await addAccountIdentityAssignment({
    newBearerToken: userData.access_token,
    bearerToken: bearerToken,
    accountUserId: userAccountInfo.sub,
  })
}

function Callback() {
  const { userData } = useAuth()
  const hasCalledBackRef = useRef(false)

  const addIdentityToken = localStorage.getItem('addIdentityToken')
  const isAddIdentity = localStorage.getItem('isAddIdentity')

  useEffect(() => {
    if (!userData?.access_token) {
      return
    }

    if (hasCalledBackRef.current) {
      return
    }

    async function processCallback() {
      console.log(userData)

      await saveTokenCookie({ cookieName, userData })

      if (isAddIdentity) {
        if (accountUrl) {
          await addIdentity({
            bearerToken: addIdentityToken,
            userData: userData,
          })
        } else {
          console.error('REACT_APP_ACCOUNT_URL must be set to add an identity')
        }
      }

      localStorage.removeItem('addIdentityToken')
      localStorage.removeItem('isAddIdentity')

      // Redirect to returnUrl or root if none is provided
      const returnUrl =
        localStorage.getItem('returnUrl') ||
        getEnv('REACT_APP_DEFAULT_RETURN_URL') ||
        '/'
      window.location.href = returnUrl
    }

    processCallback()
    hasCalledBackRef.current = true
  }, [userData, addIdentityToken])

  return <p>Processing...</p>
}

export default Callback
